// React and Libraries
import React from "react";
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

// Antd
import { UserOutlined, EditFilled, CheckOutlined } from '@ant-design/icons';
import { Tooltip, notification, } from 'antd';

// UI Library
import H3Text from '@Uilib/h3Text';

// Common Components
import ViewCustomFields from '@Components/Common/CustomField/ViewCustomFields';

// Helpers
import Helpers from '@Apis/helpers';

function ViewDCLeftSectionDocDetails ({
  props,
  state,
  getRecipient,
  updateState,
}) {

  const { selectedDC, quickUpdateEntityWise, getActivityLog, user, isQuickView, } = props;

  const { isGstNumberEditable, updatedGstNumber, documentUINames, } = state;

  return (
    <div className="document-header">
      <div className="ant-row">
        {getRecipient()?.recipient && (
          <div className="ant-col-md-24">
            <H3Text
              text={(
                <span>
                  <UserOutlined />
                  {' '}
                  <span>{getRecipient()?.recipient}</span>
                </span>
              )}
              className="document-header__party-name"
            />
          </div>
        )}
        <div className="ant-col-md-12">
          <Tooltip title={selectedDC?.tenant_name}>
            <div className="document-header__field">
              <H3Text text="Location" className="document-header__field-name" />
              <H3Text text={selectedDC?.tenant_name?.length > 25 ? `${selectedDC?.tenant_name?.substring(0, 25)}..` : selectedDC?.tenant_name} className="document-header__field-value" />
            </div>
          </Tooltip>
        </div>
        {selectedDC?.department_name && (
          <div className="ant-col-md-12">
            <div className="document-header__field">
              <H3Text text="Department" className="document-header__field-name" />
              <H3Text text={selectedDC?.department_name} className="document-header__field-value" />
            </div>
          </div>
        )}
        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text text="Challan Date" className="document-header__field-name" />
            <H3Text
              text={selectedDC?.dc_date ? (dayjs(selectedDC?.dc_date).format('DD/MM/YYYY')) : '-'}
              className="document-header__field-value"
            />
          </div>
        </div>
        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text text="Delivery Date" className="document-header__field-name" />
            <H3Text
              text={selectedDC?.delivery_date ? (dayjs(selectedDC?.delivery_date).format('DD/MM/YYYY')) : '-'}
              className="document-header__field-value"
            />
          </div>
        </div>
        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text text="GSTIN" className="document-header__field-name" />
            {(isGstNumberEditable) && (
              <div className="document-header__field-input">
                <input
                  value={updatedGstNumber}
                  onChange={(e) => {
                    updateState({ updatedGstNumber: e.target.value });
                  }}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      updateState({ isGstNumberEditable: false });
                      quickUpdateEntityWise({
                        gst_number: updatedGstNumber || null,
                        delivery_challan_id: selectedDC.delivery_challan_id,
                        entity_name: 'DELIVERY_CHALLAN',
                      }, () => {
                        getActivityLog(selectedDC.delivery_challan_id, 'delivery_challan', 1, 10);
                        // updateState({ isHsnEditable: true });
                      },
                      //  updateState({ isHsnEditable: false })
                      );
                    }
                  }}
                  className="document-custom-input"
                  maxLength="15"
                />
                &nbsp;
                <CheckOutlined
                  style={{ color: '#1890ff', cursor: 'pointer' }}
                  onClick={() => {
                    updateState({ isGstNumberEditable: false });
                    quickUpdateEntityWise({
                      gst_number: updatedGstNumber || null,
                      delivery_challan_id: selectedDC?.delivery_challan_id,
                      entity_name: 'DELIVERY_CHALLAN',
                    }, () => {
                      getActivityLog(selectedDC?.delivery_challan_id, 'delivery_challan', 1, 10);
                    //  updateState({ isHsnEditable: false })
                      },
                    );
                  }}
                />
              </div>
            )}
            {(!isGstNumberEditable) && (
              <div className="document-header__field-value">
                {updatedGstNumber && (
                  <H3Text text={updatedGstNumber} />
                )}
                {selectedDC?.status !== 'VOID' && Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.UPDATE, user) && (<EditFilled
                  className="edit-icon"
                  onClick={() => {
                    if(selectedDC?.e_way_bills?.length > 0) {
                      notification.open({
                        type: 'error',
                        message: 'Cannot update address after e-way bill is generated',
                        duration: 4,
                        placement: 'top',
                      });
                    } else {
                    updateState({ isGstNumberEditable: true });
                    }
                  }
                }
                />)}
              </div>
            )}
          </div>
        </div>
        {(selectedDC?.consumption_order_id || selectedDC?.invoice_id || selectedDC?.order_id || selectedDC?.stock_transfer_number) && (
          <div className="ant-col-md-12">
            <div className="document-header__field">
              <H3Text
                text={
                  selectedDC?.consumption_order_id
                    ? 'ConsumptionOrder#'
                    : selectedDC?.invoice_id
                      ? 'Invoice#'
                      : selectedDC?.order_id
                        ? `${documentUINames?.salesOrderUIName || 'Sales Order'} #`
                        : 'Stock Transfer#'
                }
                className="document-header__field-name"
              />
              <H3Text
                text={
                  <Link
                    to={
                      selectedDC?.consumption_order_id
                        ? `/sales/consumption/view/${selectedDC?.consumption_order_id}`
                        : selectedDC?.invoice_id
                        ? `/sales/invoice/view/${selectedDC?.invoice_id}`
                        : selectedDC?.order_id
                        ? `/sales/sales-order/view/${selectedDC?.order_id}`
                        : selectedDC?.stock_transfer_id
                        ? `/inventory/stock-transfer/view/${selectedDC?.stock_transfer_id}`
                        : "#"
                    }
                    target="_blank"
                  >
                    {
                      selectedDC?.consumption_order_id || selectedDC?.invoice_id
                        ? selectedDC?.invoice_number
                        : selectedDC?.order_id
                        ? selectedDC?.sales_order_number
                        : selectedDC?.stock_transfer_number
                    }

                  </Link>
                }
                className="document-header__field-value"
              />

            </div>
          </div>
        )}
        {(selectedDC?.custom_fields?.length > 0 && !isQuickView) ? (
          <ViewCustomFields
            customFields={selectedDC?.custom_fields?.filter((cf) => cf.is_active)}
            wrapperClass="document-header__field"
            labelClass="document-header__field-name"
            valueClass="document-header__field-value"
            isHorizontal
          />
        ) : ''}
      </div>
    </div>
  )
};

export default ViewDCLeftSectionDocDetails;